import ChatBadge from './ChatBadge';

export default ChatBadge;
